module.exports = __webpack_public_path__ + "sgby/img/short-active.421a097.png";